export default __webpack_public_path__ + "static/media/Snd_LowerIDot.7a9e7dc3.mp3";